module.exports = __webpack_public_path__ + "img/logo.c2f5764e.webp";